var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 1.88a6.9 6.9 0 0 0-6.87 6.87v3.75c0 .8.52 1.5 1.25 1.76v.12c0 1.71 1.4 3.12 3.12 3.12h.8c.22.37.61.63 1.07.63h1.26a1.25 1.25 0 0 0 0-2.5H9.37c-.46 0-.85.25-1.07.62h-.8a1.9 1.9 0 0 1-1.87-1.87h1.25V8.75h-2.5c0-3.1 2.52-5.62 5.62-5.62s5.63 2.52 5.63 5.62h-2.5v5.63H15c1.03 0 1.88-.85 1.88-1.88V8.75A6.9 6.9 0 0 0 10 1.88M4.38 10h1.25v3.13H5a.6.6 0 0 1-.62-.63zm10 0h1.24v2.5c0 .35-.27.63-.62.63h-.62z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadset);
export default ForwardRef;